<template>
    <span :class="'badge-' + colorBadge"
          class="badge badge-pill badge-measurement">{{moment(controlDate).format('DD/MM/Y')}}</span>
</template>
<script>
    export default {
        props: ['controlDate'],
        computed: {
            colorBadge() {
                let date = this.moment(this.controlDate)
                let today = this.moment().format('Y-MM-DD')
                let monthAgo = this.moment().subtract(1, 'M').format('Y-MM-DD')
                let color = 'danger'

                if(date.isBefore(today) && date.isAfter(monthAgo)){
                    color = 'warning'
                }else if (date.isAfter(today)) {
                    color = 'light'
                }
                return color
            }
        }
    }
</script>
